import { makeRouteConfig, Route, RouteProps } from 'found'

import { fetchRouteShift } from './actions/api'
import App from './App'
import AboutPage from './pages/AboutPage'
import ActAsToolPage from './pages/ActAsToolPage'
import BusDriverCheckInPage from './pages/BusDriverCheckInPage'
import BusDriverCheckInsListPage from './pages/BusDriverCheckInsListPage'
import CompositionPage from './pages/CompositionPage'
import ContactsPage from './pages/ContactsPage'
import CreateDefectPage from './pages/CreateDefectPage'
import CustomerFeedbackPage from './pages/CustomerFeedbackPage'
import DefectsPage from './pages/DefectsPage'
import DeviationAmendmentPage from './pages/DeviationAmendmentPage'
import DeviceManagementPage from './pages/DeviceManagementPage'
import DevPage from './pages/DevPage'
import FeedbackPage from './pages/FeedbackPage'
import FrontPage from './pages/FrontPage'
import OptionsPage from './pages/OptionsPage'
import PersonnelListPage from './pages/PersonnelListPage'
import PunctualityPage from './pages/PunctualityPage'
import RestritionInfoPage from './pages/RestrictionInfoPage'
import SchedulePage from './pages/SchedulePage'
import CompositionSearchPage from './pages/search/CompositionSearchPage'
import PersonnelSearchPage from './pages/search/PersonnelSearchPage'
import PunctualitySearchPage from './pages/search/PunctualitySearchPage'
import SearchToolPage from './pages/search/SearchToolPage'
import ShiftSearchPage from './pages/search/ShiftSearchPage'
import TimetableSearchPage from './pages/search/TimetableSearchPage'
import TowingSearchPage from './pages/search/TowingSearchPage'
import ActionsPage from './pages/serviceOrders/ActionsPage'
import ServiceOrderPage from './pages/serviceOrders/ServiceOrderPage'
import ServiceOrdersListPage from './pages/serviceOrders/ServiceOrdersListPage'
import ShiftInstructions from './pages/ShiftInstructions'
import ShiftPage from './pages/ShiftPage'
import SmDisruptionsPage from './pages/SmDisruptionsPage'
import TowingPage from './pages/TowingPage'

const routes = () => {
  const renderRoute = ({ Component, props }: RouteProps) => {
    if (Component && props) {
      return <Component {...props} />
    }
  }

  return makeRouteConfig(
    <Route path="/" Component={App} render={renderRoute}>
      <Route path="/" Component={FrontPage} />
      <Route path="/token/:token" Component={FrontPage} />
      <Route path="/check-in" Component={BusDriverCheckInPage} />
      <Route path="/bus-driver-check-ins" Component={BusDriverCheckInsListPage} />
      <Route path="/shifts" Component={SchedulePage} />
      <Route path="/search" Component={SearchToolPage} />
      <Route path="/search/defects" Component={DefectsPage} />
      <Route path="/search/contacts" Component={ContactsPage} />
      <Route path="/search/serviceOrders" Component={ServiceOrdersListPage} />
      <Route path="/search/personnel" Component={PersonnelSearchPage} />
      <Route path="/search/compositions" Component={CompositionSearchPage} />
      <Route path="/search/shifts" Component={ShiftSearchPage} />
      <Route path="/search/fallbackTimetables" Component={TimetableSearchPage} />
      <Route path="/search/punctuality" Component={PunctualitySearchPage} />
      <Route path="/search/towings" Component={TowingSearchPage} />
      <Route path="/personnelList/*" Component={PersonnelListPage} />
      <Route
        path="/shifts/:shiftId/list-feedback/:stars/"
        schedule={true}
        Component={FeedbackPage}
      />
      <Route
        path="/shifts/:shiftId"
        Component={ShiftPage}
        getData={({ context }) => context.store.dispatch(fetchRouteShift())}
      />
      <Route path="/shifts/:shiftId/feedback/:stars/" schedule={false} Component={FeedbackPage} />
      <Route path="/shiftInstructions/*" Component={ShiftInstructions} />
      <Route path="/serviceOrders/:orderId" Component={ServiceOrderPage} />
      <Route
        path="/serviceOrders/:orderId/activity/:activityId/task/:taskId"
        Component={ActionsPage}
      />
      <Route path="/restrictionInfos/:equipmentIds" Component={RestritionInfoPage} />
      <Route path="/composition/*" Component={CompositionPage} />
      <Route path="/punctuality/*" Component={PunctualityPage} />
      <Route
        path="/amendDeviationReason/:trainNumber/:runningDate/:ocpCode/:depOrArr"
        Component={DeviationAmendmentPage}
      />
      <Route path="/options" Component={OptionsPage} />
      <Route path="/about" Component={AboutPage} />
      <Route path="/dev" Component={DevPage} />
      <Route path="/customerFeedback" Component={CustomerFeedbackPage} />
      <Route path="/deviceManagement" Component={DeviceManagementPage} />
      <Route path="/towing/:id/:formType" Component={TowingPage} />
      <Route path="/actAsTool" Component={ActAsToolPage} />
      <Route path="/defects" Component={DefectsPage} />
      <Route path="/create-defect" Component={CreateDefectPage} />
      <Route path="/smDisruptions" Component={SmDisruptionsPage} />
    </Route>
  )
}

export default routes
